module.exports = __webpack_public_path__ + "static/media/PartnersSvgEng.4a197307.svg";